import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ChartsModule } from 'ng2-charts';
import { CircleDiagram } from '@core/components/diagrams/circle-diagram/circle-diagram';
import { LineChartComponent } from '@core/components/diagrams/line-chart/line-chart.component';

@NgModule({
  declarations: [
    CircleDiagram,
    LineChartComponent,
  ],
  imports     : [
    CommonModule,
    IonicModule,
    ChartsModule,
  ],
  exports     : [
    CircleDiagram,
    LineChartComponent,
  ]
})
export class DiagramsModule {
}
